import React, { Component } from "react";
import QuestionDialog from "../../components/settings/QuestionDialog";
import CreateIcon from "@material-ui/icons/Create";
import IconButton from "@material-ui/core/IconButton";
import { languages } from "../../constants/languages";
import Button from "@material-ui/core/Button";
import moment from "moment-timezone";

class QuestionContainer extends Component {
  state = {
    open: false,
    name: "",
    type: "0",
    choices: {},
    reqOrOpt: "0",
    submitDisabled: true,
    perSignup: false,
    trs: {},
    trsChoices: {},
    lang: "0",
  };

  toggleDialog = () => {
    if (!this.state.open && this.props.question) {
      this.updateState(this.props.question);
    }
    this.setState({ open: !this.state.open });
  };

  UNSAFE_componentWillMount = () => {
    const question = this.props.question;
    if (question) {
      this.updateState(question);
    }
  };

  updateState = (question) => {
    const choices = question.choices
      ? JSON.parse(JSON.stringify(question.choices))
      : {};
    const trsChoices = question.trsChoices
      ? JSON.parse(JSON.stringify(question.trsChoices))
      : {};
    this.setState({
      name: question.name || "",
      type: question.type || "0",
      choices: choices,
      reqOrOpt: question.reqOrOpt || "0",
      perSignup: question.perSignup || false,
      trs: question.trs || {},
      trsChoices: trsChoices,
    });
  };

  handleChange = (event) => {
    let newState = {};
    newState[event.target.name] = event.target.value;
    if (event.target.name === "name") {
      if (event.target.value.length > 0) {
        newState["submitDisabled"] = false;
      } else {
        newState["submitDisabled"] = true;
      }
    } else if (this.props.question) {
      newState["submitDisabled"] = false;
    }
    this.setState(newState);
  };

  handleTrsNameChange = (event) => {
    let trs = this.state.trs;
    trs[this.state.lang] = event.target.value;

    this.setState({ trs: trs });
  };

  handleChoicesChange = (event) => {
    let choices =
      this.state.lang !== "0"
        ? this.state.trsChoices[this.state.lang] || {}
        : this.state.choices;
    let choiceKey = event.target.name;
    choices[choiceKey] = event.target.value;
    if (choices[choiceKey] === "") {
      delete choices[choiceKey];
    }

    let toUpdate = {
      submitDisabled: this.state.name.length > 0 ? false : true,
    };
    if (this.state.lang !== "0") {
      let trsChoices = this.state.trsChoices;
      trsChoices[this.state.lang] = choices;
      toUpdate["trsChoices"] = trsChoices;
    } else {
      toUpdate["choices"] = choices;
    }
    this.setState(toUpdate);
  };

  handleSubmit = (e) => {
    e.preventDefault();
    this.setState({ submitDisabled: true });
    this.toggleDialog();
    const tournamentRef = window.firebase
      .firestore()
      .collection("tournaments")
      .doc(this.props.tournament[".key"]);

    let questions = this.props.tournament.questions || {};

    if (
      this.props.question &&
      this.props.question.id !== "0" &&
      this.props.question.id !== "1" &&
      this.props.question.id !== "2" &&
      this.props.question.id !== "3" &&
      this.props.question.id !== "4"
    ) {
      questions[this.props.question.id]["name"] = this.state.name;
      questions[this.props.question.id]["type"] = this.state.type;
      questions[this.props.question.id]["choices"] = this.state.choices;
      questions[this.props.question.id]["reqOrOpt"] = this.state.reqOrOpt;
      questions[this.props.question.id]["perSignup"] = this.state.perSignup;
      questions[this.props.question.id]["trs"] = this.state.trs;
      questions[this.props.question.id]["trsChoices"] = this.state.trsChoices;
    } else {
      let questionId = moment().unix().toString();
      questions[questionId] = {};
      questions[questionId]["name"] = this.state.name;
      questions[questionId]["show"] = true;
      questions[questionId]["type"] = this.state.type;
      questions[questionId]["choices"] = this.state.choices;
      questions[questionId]["reqOrOpt"] = this.state.reqOrOpt;
      questions[questionId]["perSignup"] = this.state.perSignup;
      questions[questionId]["trs"] = this.state.trs;
      questions[questionId]["trsChoices"] = this.state.trsChoices;
    }

    let toUpdate = {};
    if ((this.props.question || {}).id === "0") {
      toUpdate["teamSignupQuestion"] = this.state.name;
      toUpdate["trsTeamSignupQuestion"] = this.state.trs;
    } else if ((this.props.question || {}).id === "1") {
      toUpdate["teamSignupQuestion2"] = this.state.name;
      toUpdate["trsTeamSignupQuestion2"] = this.state.trs;
    } else if ((this.props.question || {}).id === "2") {
      toUpdate["individualPlayersSignupQuestion"] = this.state.name;
      toUpdate["trsIndividualPlayersSignupQuestion"] = this.state.trs;
    } else if ((this.props.question || {}).id === "3") {
      toUpdate["countrySignupQuestion"] = this.state.name;
      toUpdate["trsCountrySignupQuestion"] = this.state.trs;
    } else if ((this.props.question || {}).id === "4") {
      toUpdate["divisionSignupQuestion"] = this.state.name;
      toUpdate["trsDivisionSignupQuestion"] = this.state.trs;
    } else {
      toUpdate["questions"] = questions;
    }

    tournamentRef
      .update(toUpdate)
      .then(() => {
        if (this.props.question) {
          this.setState({ submitDisabled: true });
        } else {
          this.setState({
            submitDisabled: true,
            name: "",
            type: "0",
            choices: {},
            reqOrOpt: "0",
            perSignup: false,
            trs: {},
            trsChoices: {},
            lang: "0",
          });
        }
      })
      .catch((error) => {
        this.setState({ submitDisabled: false });
      });
  };

  render() {
    return (
      <div>
        {this.props.question ? (
          <IconButton
            aria-label="Change"
            onClick={this.toggleDialog}
            disabled={this.props.disabled}
            style={{ height: 30, width: 30 }}
          >
            <CreateIcon
              style={{ height: 20, width: 20, position: "absolute", top: 5 }}
            />
          </IconButton>
        ) : (
          <Button
            variant="outlined"
            color="default"
            onClick={this.toggleDialog}
            fullWidth
          >
            {languages.signupPage.addQuestion}
          </Button>
        )}
        <QuestionDialog
          name={
            this.state.lang !== "0"
              ? this.state.trs[this.state.lang] || ""
              : this.state.name
          }
          submitDisabled={this.state.submitDisabled}
          open={this.state.open}
          type={this.state.type}
          choices={this.state.choices}
          reqOrOpt={this.state.reqOrOpt}
          perSignup={this.state.perSignup}
          handleChoicesChange={this.handleChoicesChange}
          question={this.props.question}
          toggleDialog={this.toggleDialog}
          handleChange={this.handleChange}
          handleSubmit={this.handleSubmit}
          tournament={this.props.tournament}
          lang={this.state.lang}
          trsChoices={this.state.trsChoices}
          handleTrsNameChange={this.handleTrsNameChange}
        />
      </div>
    );
  }
}

export default QuestionContainer;
